import { guideSteps } from "@/mocks/home";

export default function GuideSteps() {
  return (
    <section id="guide" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
          <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">PLAYBOOK</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              使用攻略
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              五个步骤，按这个顺序走，新手也不会绕路。每一步都写了"为什么这么做"，
              看懂之后再回头用获取方式会顺很多。
            </p>
            <div className="mt-7 flex items-center gap-3 p-4 rounded-lg bg-secondary-50 border border-secondary-200">
              <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-secondary-500 text-background-50">
                <i className="ri-lightbulb-line"></i>
              </span>
              <p className="text-sm leading-6 text-secondary-900">
                如果只记得住一步，就记住：先确定要看哪一类。
              </p>
            </div>
          </div>

          <ol className="lg:col-span-8">
            {guideSteps.map((item, i) => (
              <li key={item.step} className="relative flex gap-5 md:gap-7 pb-9 last:pb-0">
                <div className="flex flex-col items-center shrink-0">
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold">
                    {i + 1}
                  </span>
                  {i < guideSteps.length - 1 && (
                    <span className="flex-1 w-px bg-foreground-950/15 my-2"></span>
                  )}
                </div>
                <div className="pt-1.5">
                  <p className="text-[11px] tracking-[0.25em] text-foreground-400">{item.step}</p>
                  <h3 className="mt-2 font-heading text-lg md:text-xl font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2.5 text-sm md:text-base leading-7 text-foreground-600">
                    {item.desc}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}